'use client';

import React from 'react';
import Script from 'next/script';

interface Props {
  gtmId: string
  gtmScriptUrl?: string
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  dataLayer?: { [key: string]: any }
  dataLayerName?: string
  auth?: string
  preview?: string
  nonce?: string
}

let currDataLayerName = 'dataLayer';

export const GoogleTagManager: React.FC<Props> = ({
  gtmId,
  gtmScriptUrl = 'https://www.googletagmanager.com/gtm.js',
  dataLayerName = 'dataLayer',
  auth,
  preview,
  dataLayer,
  nonce,
}) => {
  currDataLayerName = dataLayerName;

  const gtmLayer = dataLayerName !== 'dataLayer' ? `&l=${dataLayerName}` : '';
  const gtmAuth = auth ? `&gtm_auth=${auth}` : '';
  const gtmPreview = preview ? `&gtm_preview=${preview}&gtm_cookies_win=x` : '';

  return (
    <React.Fragment>
      <Script
        id="_next-gtm-init"
        dangerouslySetInnerHTML={{
          __html: `
      (function(w,l){
        w[l]=w[l]||[];
        w[l].push({'gtm.start': new Date().getTime(),event:'gtm.js'});
        ${dataLayer ? `w[l].push(${JSON.stringify(dataLayer)})` : ''}
      })(window,'${dataLayerName}');`,
        }}
        nonce={nonce}
      />
      <Script
        id="_next-gtm"
        data-ntpc="GTM"
        src={`${gtmScriptUrl}?id=${gtmId}${gtmLayer}${gtmAuth}${gtmPreview}`}
        nonce={nonce}
      />
    </React.Fragment>
  );
};

export const sendGTMEvent = (data: object, dataLayerName?: string) => {
  const dataLayer = dataLayerName || currDataLayerName;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  (window as any)[dataLayer] = (window as any)[dataLayer] || [];
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  (window as any)[dataLayer].push(data);
};
